// extracted by css-extract-rspack-plugin
export default {"nav":"VPwrsv7HvZksuB6u","heading":"jbAoMRGNAKqdXTss","list":"bknkFBGYqFYE5pzA","item":"RydWVr7woDwuk1VL","itemLink":"k2sZT3t30Cwk1t5c","itemLinkActive":"EiDS116cJd8tLFDa"};